import { render, staticRenderFns } from "./QuizTab.vue?vue&type=template&id=157e9286&scoped=true&"
import script from "./QuizTab.vue?vue&type=script&lang=js&"
export * from "./QuizTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157e9286",
  null
  
)

export default component.exports